import { MyDocumentsListPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import DocumentURLContext from 'modules/documents/components/Documents/List/DocumentURLContext'
import DocumentsAndFolders from 'modules/documents/components/DocumentsAndFolders'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const DocumentsListPage = () => {
  const { employee } = useCurrentSession()
  const { navigation } = useNavigation()

  const documentRoutesContext = {
    show: (id: string | number) =>
      navigation.documents.list.documentId.fullPath({ document_id: id }),
  }

  const { loading, data, error } = useQuery(MyDocumentsListPageDocument, {
    variables: { employeeId: Number(employee?.id) },
  })

  const canUploadFolderDocument =
    data?.employees?.employee?.folders?.some((folder) => folder._policies?.edit?.can) ?? false

  const canUploadWithoutFolderDocument =
    data?.employees?.employee?._policies?.editEmployeeDocumentsWithoutFolder?.can ?? false

  return (
    <DocumentURLContext.Provider value={documentRoutesContext}>
      <ResponsivePage.Body showHeader={false} loading={loading} error={error}>
        <DocumentsAndFolders
          parentRoute={navigation.documents.list.fullPath()}
          canUploadDocument={canUploadFolderDocument || canUploadWithoutFolderDocument}
        />
      </ResponsivePage.Body>
    </DocumentURLContext.Provider>
  )
}

export default DocumentsListPage
